// extracted by mini-css-extract-plugin
module.exports = {"markdown":"styles_markdown__1sd6F"};